import gsap from 'gsap';

/**
 * Applies the GSAP "slide + reset" animation to an element (containing an SVG)
 * @param {HTMLElement} element - The parent element of the SVG (ex: .btn.has-icon, .swiper-prev, ...)
 * @param {('right'|'left')} direction - Animation direction ('right' = to the right, 'left' = to the left)
 */
export function btnArrowOnHover(element, direction = 'right') {
    const svg = element.querySelector('svg');
    if (!svg) return;
    let tl = null;
    const start = direction === 'right' ? 150 : -150;
    const end = direction === 'right' ? -150 : 150;

    element.addEventListener('mouseenter', () => {
        if (tl) tl.kill();
        tl = gsap.timeline();
        tl.to(svg, {
            xPercent: start,
            // opacity: 0,
            duration: 0.3,
            ease: "power1.in",
            onComplete: () => {
                gsap.set(svg, {
                    xPercent: end,
                    // opacity: 0
                });
            }
        })
            .to(svg, {
                xPercent: 0,
                // opacity: 1,
                duration: 0.3,
                ease: "power1.out"
            });
    });

    element.addEventListener('mouseleave', () => {
        if (tl) tl.kill();
        gsap.to(svg, {
            xPercent: 0,
            // opacity: 1,
            duration: 0.2,
            overwrite: true,
            ease: "power1.out"
        });
    });
}
